// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CarouselInfo_wrapper__hdj8r","infomationContainer":"CarouselInfo_infomationContainer__avD9g","header":"CarouselInfo_header__mITX5"};